import { render, staticRenderFns } from "./ListagemGrupoRotaComponent.vue?vue&type=template&id=166c18f0"
import script from "./ListagemGrupoRotaComponent.vue?vue&type=script&lang=js"
export * from "./ListagemGrupoRotaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports